"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.name");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _loading = require("@/mixins/loading/loading");

var _railway = require("@/mixins/railway/railway");

var _elementUi = require("element-ui");

var _orderDateRange = _interopRequireDefault(require("@/views/railway/components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("@/views/railway/components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("@/views/railway/components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("@/views/railway/components/order-table/order-table.vue"));

var _planHeader = _interopRequireDefault(require("@/views/railway/components/plan-header/plan-header.vue"));

var _moment = _interopRequireDefault(require("moment"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

var _permission = require("@/mixins/permission/permission");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRManualAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRManualAssignComponent, _Mixins);

  var _super = _createSuper(MRManualAssignComponent);

  function MRManualAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRManualAssignComponent);
    _this = _super.apply(this, arguments);
    _this.today = (0, _moment.default)(new Date()).format('YYYY-MM-DD');
    _this.orderData = [];
    return _this;
  }

  (0, _createClass2.default)(MRManualAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        'top': !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('beforeunload', this.handleClose);
    }
  }, {
    key: "created",
    value: function () {
      var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (window.innerWidth < _variables.default['md-min']) {
                  this.$isMobile = true;
                }

                _context.next = 3;
                return this.getData();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.addEventListener('beforeunload', this.handleClose);
                _context2.next = 3;
                return this.$getUnassignedOrders();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      if (this.$anyChanges) {
        e.preventDefault();
        e.returnValue = this.$i18n.t('general.stillSomeChanges');
      }
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.railwayAPI.getPlan({
                  status: 'active'
                });

              case 2:
                res = _context3.sent;
                message = {
                  title: this.$i18n.t('general.getSuccess'),
                  duration: 5000
                };

                if (!(this.helper.isUndefined(res) || res.failed)) {
                  _context3.next = 8;
                  break;
                }

                message.title = this.$i18n.t('general.getFailed');

                _elementUi.Notification.error(message);

                return _context3.abrupt("return");

              case 8:
                // Notification.success(message);
                this.orderData = (0, _toConsumableArray2.default)(this.helper.get(res, 'data', []));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "handleManualAssign",
    value: function () {
      var _handleManualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(planId) {
        var orderIds, res, message, orderData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.isManualAssignLoading = true; // const prefix = this.helper.generatePlanId('', this.$userInformation.company.name);
                // const prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, '', this.$userInformation, 'railway');
                // const planIds = await this.routeAPI.generateLoadPlanId(prefix, 1);
                // const planId = this.helper.get(planIds, 'data.0', []);

                orderIds = this.helper.map(this.$selectedOrders, 'id');
                _context4.next = 4;
                return this.railwayAPI.insertPlan({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.today,
                  planId: planId,
                  routes: this.$selectedOrders
                });

              case 4:
                res = _context4.sent;
                message = {
                  title: this.$i18n.t('general.insertSuccess'),
                  duration: 5000
                };

                if (!(this.helper.isUndefined(res) || res.failed)) {
                  _context4.next = 11;
                  break;
                }

                message.title = this.$i18n.t('general.insertFailed');

                _elementUi.Notification.error(message);

                this.isManualAssignLoading = false;
                return _context4.abrupt("return");

              case 11:
                _elementUi.Notification.success(message);

                orderData = this.helper.get(res, 'data', []);
                this.orderData = [].concat((0, _toConsumableArray2.default)(this.orderData), (0, _toConsumableArray2.default)(orderData));
                _context4.next = 16;
                return this.updateOrderTable({
                  orderIds: orderIds,
                  invalidOrderIds: [],
                  orderData: orderData
                });

              case 16:
                this.isManualAssignLoading = false;

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleManualAssign(_x) {
        return _handleManualAssign.apply(this, arguments);
      }

      return handleManualAssign;
    }()
  }, {
    key: "updateOrderTable",
    value: function () {
      var _updateOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref) {
        var _this2 = this;

        var orderIds, invalidOrderIds, orderData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                orderIds = _ref.orderIds, invalidOrderIds = _ref.invalidOrderIds, orderData = _ref.orderData;
                this.$selectedOrders = [];
                this.$excludedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$excludedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return !_this2.helper.includes(invalidOrderIds, oId);
                }))));
                this.$includedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return _this2.helper.includes(invalidOrderIds, oId);
                }))));
                _context5.next = 6;
                return this.$getUnassignedOrders();

              case 6:
                _context5.next = 8;
                return this.railwayAPI.updateOrdersInPlan({
                  orders: this.getOrders(orderData, this.today, 'save')
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateOrderTable(_x2) {
        return _updateOrderTable.apply(this, arguments);
      }

      return updateOrderTable;
    }()
  }, {
    key: "getOrders",
    value: function getOrders() {
      var orderData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';

      if (this.helper.isUndefined(orderData) || !orderData.length) {
        return;
      }

      var finalOrders = [];

      switch (type) {
        case 'save':
          orderData.forEach(function (oData) {
            var finalOrder = finalOrders.length >= 1 ? finalOrders.find(function (fOrder) {
              return fOrder['planId'] === oData['planId'];
            }) : null;

            if (finalOrder) {
              finalOrder['orderId'] = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(finalOrder['orderId']), (0, _toConsumableArray2.default)(oData['orderId']))));
            } else {
              if (oData['planId'] && oData['orderId']) {
                finalOrders.push({
                  'planCode': code,
                  'planId': oData['planId'],
                  'orderId': (0, _toConsumableArray2.default)(new Set(oData['orderId']))
                });
              }
            }
          });
          break;
      }

      if (this.$includedOrders && this.$includedOrders.length >= 1) {
        finalOrders.push({
          'planCode': '',
          'planId': '',
          'orderId': this.$includedOrders
        });
      }

      return finalOrders;
    }
  }, {
    key: "deleteOrder",
    value: function () {
      var _deleteOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(order) {
        var res, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isManualAssignLoading = true;
                _context6.next = 3;
                return this.railwayAPI.deleteRoute({
                  id: order['_id']
                });

              case 3:
                res = _context6.sent;
                message = {
                  title: this.$i18n.t('general.deleteSuccess'),
                  duration: 5000
                };

                if (!(this.helper.isUndefined(res) || res.failed)) {
                  _context6.next = 10;
                  break;
                }

                message.title = this.$i18n.t('general.deleteFailed');

                _elementUi.Notification.error(message);

                this.isManualAssignLoading = false;
                return _context6.abrupt("return");

              case 10:
                _elementUi.Notification.success(message);

                this.$excludedOrders = (0, _toConsumableArray2.default)(this.$excludedOrders).filter(function (oId) {
                  return oId !== order['orderId'][0];
                });
                _context6.next = 14;
                return this.railwayAPI.updateOrdersInPlan({
                  orders: [{
                    'planCode': '',
                    'planId': '',
                    'orderId': order['orderId']
                  }]
                });

              case 14:
                _context6.next = 16;
                return this.$getUnassignedOrders();

              case 16:
                _context6.next = 18;
                return this.getData();

              case 18:
                this.isManualAssignLoading = false;

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteOrder(_x3) {
        return _deleteOrder.apply(this, arguments);
      }

      return deleteOrder;
    }()
  }]);
  return MRManualAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _railway.RailwayMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRManualAssignComponent.prototype, "$isFullscreen", void 0);
MRManualAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'RailwayManualAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'plan-header': _planHeader.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-button': _elementUi.Button
  }
})], MRManualAssignComponent);
var _default = MRManualAssignComponent;
exports.default = _default;